import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Radio from "components/Radio";

import styles from "forms/forms.css";

const RadioField = ({
  children,
  className,
  field: { name },
  form: { errors, setFieldValue, submitCount, values },
  label,
  value,
}) => (
  <div className={cx(styles.field, className)}>
    <Radio
      isChecked={value === values[name]}
      isInvalid={!!submitCount && errors[name]}
      label={label}
      onChange={() => setFieldValue(name, value)}
    >
      {children}
    </Radio>
  </div>
);

RadioField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.bool,
  }),
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  form: PropTypes.shape({
    errors: PropTypes.object,
    submitCount: PropTypes.number,
    setFieldValue: PropTypes.func,
  }),
  value: PropTypes.string,
};

export default RadioField;
